/** Strip trailing slashes. Empty input becomes `""`; bare `/` stays `/`. */
export function stripTrailingSlashes(path: string): string {
  if (!path) return ""
  const stripped = path.replace(/\/+$/, "")
  return stripped === "" ? "/" : stripped
}

/** Ensure a pathname ends with exactly one trailing slash. */
export function withTrailingSlash(path: string): string {
  if (!path) return "/"
  return `${stripTrailingSlashes(path)}/`
}

/** Compare pathnames, ignoring trailing slash differences. */
export function pathsEqual(
  pathA: string | null | undefined,
  pathB: string | null | undefined
): boolean {
  if (!pathA || !pathB) return false
  return stripTrailingSlashes(pathA) === stripTrailingSlashes(pathB)
}
